<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon class="mr-5 scale-150">emoji_events</mat-icon>
            <h1 class="text-3xl font-medium">Achievements</h1>
        </div>
    </header>
    @if (achievementsStore.isFulfilled()) {
        <mat-form-field class="w-full">
            <mat-label>Search</mat-label>
            <input
                matInput
                (keyup)="applyFilter($event)" />
        </mat-form-field>
        <button
            mat-flat-button
            color="primary"
            routerLink="/{{
                ComponentRoutes.achievements.achievement.replace(':achievementId', '0')
            }}">
            Add achievement
        </button>
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="title"
            matSortDirection="asc"
            matSortDisableClear>
            <ng-container matColumnDef="logo">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <img
                        class="size-16"
                        [ngClass]="{ hidden: !element.tiers?.[0]?.logoUrl }"
                        src="{{ element.tiers?.[0]?.logoUrl }}"
                        alt="" />
                </td>
            </ng-container>
            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Title
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        {{ element.title }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="active">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <mat-checkbox
                            disabled
                            [checked]="element.isActive"></mat-checkbox>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu">
                        Manage
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            mat-menu-item
                            routerLink="/{{
                                ComponentRoutes.achievements.achievement.replace(
                                    ':achievementId',
                                    element.id
                                )
                            }}">
                            Edit achievement
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
